import(/* webpackMode: "eager" */ "/srv/project/front-org/src/app/global-error.tsx");
